import { createFileRoute } from '@tanstack/react-router';
import { PageHeader, Stack } from '@leanin/ui';
import { NewInvitationForm } from '@/components/admin/NewInvitationForm';
import { AdminShell } from '@/components/admin/AdminShell';
import { PLATFORM_ADMIN_ITEMS } from '@/components/admin/admin-sidebar-items';

const MAX_OPTIONS = 100;

export const Route = createFileRoute('/_authed/admin/invitations/new/')({
  component: NewInvitationPage,
});

function NewInvitationPage() {
  return (
    <AdminShell items={PLATFORM_ADMIN_ITEMS} active="invitations">
      <Stack gap="xl">
        <PageHeader
          back={{ href: '/admin/invitations', label: 'Admin Panel · Users' }}
          title="Invite a new member"
          subtitle="Create a profile and send a join link. They'll set their own password."
        />
        <NewInvitationForm maxOptions={MAX_OPTIONS} />
      </Stack>
    </AdminShell>
  );
}
